// src/components/config.js
import configData from '../data/config.json';

// Export the API base URL from the JSON config
export const API_BASE_URL = configData.apiConfig.baseUrl;

// Dynamically build ACTIVE_FILTERS based on the filter configs
// Default all filters to true unless explicitly set to false
export const ACTIVE_FILTERS = {};

// Initialize ACTIVE_FILTERS from filter configs
Object.values(configData.filterConfig).forEach(categoryConfig => {
  Object.entries(categoryConfig.validFilters || {}).forEach(([filterName, filterConfig]) => {
    // Use the apiName as the key for ACTIVE_FILTERS
    const apiName = filterConfig.apiName;
    if (apiName) {
      // Set to true by default unless display is explicitly false
      ACTIVE_FILTERS[apiName] = filterConfig.display !== false;
    }
  });
});

// Add any additional default ACTIVE_FILTERS that might not be in the config
const defaultActiveFilters = {
  'PartyName': true,
  'TotalVotes': true,
  'CandidateName': true,
  'DistrictName': true,
  'PrecinctName': true,
  'Year': true
};

// Add defaults for any missing filters
Object.entries(defaultActiveFilters).forEach(([key, value]) => {
  if (ACTIVE_FILTERS[key] === undefined) {
    ACTIVE_FILTERS[key] = value;
  }
});

// Export filter configuration from the JSON file
export const FILTER_CONFIG = configData.filterConfig;

// Export party colors from the JSON file
export const PARTY_COLORS = configData.partyColors;

// Export welcome text if needed
export const WELCOME_TEXT = configData.welcomeText;

// Debug function to verify config is loaded properly
export const debugConfig = () => {
  console.log("Filter config loaded:", FILTER_CONFIG);
  console.log("Active filters:", ACTIVE_FILTERS);
  
  // Check if all-candidates has proper viz settings
  const allCandidatesViz = FILTER_CONFIG['all-candidates']?.validViz;
  console.log("All candidates viz settings:", allCandidatesViz);
  
  // Verify visualization boolean values
  Object.entries(FILTER_CONFIG).forEach(([key, config]) => {
    console.log(`Category ${key} valid visualizations:`, config.validViz);
    console.log(`Category ${key} valid filters:`, config.validFilters);
  });
};